import { BACKSPACE, DELETE } from '../../constants/keyboardKeys/keyboardKeys';
export const getPosition = (key, value, cursor, position) => {
    let valuePosition;
    if (key === BACKSPACE.key) {
        valuePosition = -1;
    }
    else if (key === DELETE.key) {
        valuePosition = 0;
    }
    else if (key !== value.toString().charAt(cursor.start)) {
        valuePosition = position || 2;
    }
    else {
        valuePosition = 1;
    }
    return valuePosition;
};
//# sourceMappingURL=cursor.utility.js.map